module.exports = {
    values: 30,
    interests: 40,
    workplace: 5,
    personality: 5,
};



//////////////////
// WEBPACK FOOTER
// ./src/constants/max-scores.js
// module id = 355
// module chunks = 58